/**
 * hoodieApi config — Reference Django backend (themamahood).
 * This is the hoodie backend; the app also has a main backend (see services/api.js — mainApi).
 * Base path is /api/hoodie/ (no trailing slash on origin).
 * Example: REACT_APP_HOODIE_API_BASE_URL=http://localhost:8000
 */
export const HOODIE_API_BASE_URL =
  (process.env.REACT_APP_HOODIE_API_BASE_URL || "").replace(/\/$/, "") +
  "/api/hoodie/";

export const isHoodieApiConfigured = () =>
  Boolean(process.env.REACT_APP_HOODIE_API_BASE_URL);
